export interface INavigationRoute {
  name: string
  displayName: string
  meta: {
    icon: string
    permissions?: string[]
  }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: '数据面板',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'task',
      displayName: '定时任务',
      meta: {
        icon: 'timer',
        permissions: ['can_view_admin'],
      },
    },
    {
      name: 'iptag',
      displayName: '标签管理',
      meta: {
        icon: 'tag',
        permissions: ['can_view_admin'],
      },
    },
    {
      name: 'risk',
      displayName: '风险日志',
      meta: {
        icon: 'analytics',
      },
    },
    {
      name: 'rules',
      displayName: '规则管理',
      meta: {
        icon: 'rule',
      },
      children: [
        {
          name: 'rule-iplist',
          displayName: '黑白名单',
        },
        {
          name: 'rule-common',
          displayName: '通用规则',
        },
        {
          name: 'rule-domain',
          displayName: '域名规则',
        },
      ],
    },
    {
      name: 'users',
      displayName: '用户管理',
      meta: {
        icon: 'group',
        permissions: ['can_view_admin'],
      },
    },
    {
      name: 'loginlogs',
      displayName: '登录日志',
      meta: {
        icon: 'description',
      },
    },
    {
      name: 'preferences',
      displayName: '个人中心',
      meta: {
        icon: 'mso-account_circle',
      },
    },
  ] as INavigationRoute[],
}
